import { render, staticRenderFns } from "./InstructorToolsRenderer.vue?vue&type=template&id=94e6145c&"
import script from "./InstructorToolsRenderer.vue?vue&type=script&lang=js&"
export * from "./InstructorToolsRenderer.vue?vue&type=script&lang=js&"
import style0 from "./InstructorToolsRenderer.vue?vue&type=style&index=0&id=94e6145c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports